
import { useAuth } from "contexts/AuthContext";
import { useQueryClient } from "@tanstack/react-query";

import { useMutation } from "@tanstack/react-query";

import { PartialUserProfile, UserProfile } from "utils/userProfiles";

type UseUpdateUserProfileMutationVariables = Omit<PartialUserProfile, "id">

export const useUpdateUserProfileMutation = (userId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UseUpdateUserProfileMutationVariables) => {
      const { data } = await authApi.patch<UserProfile>(`/user-profiles/user/${userId}`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["userProfile", userId],
      });
    },
  });
};